<template>
	<div id="app">
		<vheader v-show="!$route.meta.publicShow"></vheader>
		<router-view v-if="isRouterAlive" v-on:public_header="public_header" v-on:public_footer="public_footer">
		</router-view>
		<vfooter v-show="!$route.meta.publicShow"></vfooter>
	</div>
</template>

<script>
 	import Header from './components/Header.vue'
	import Footer from './components/Footer.vue'
	export default {
		name: 'app',
		provide(){
		  return{
			reload:this.reload
		  }
		},
		data() {
			return {
				isRouterAlive:true,
				header_show:true,
				footer_show:true,
			}
		},
		components:{
			'vheader':Header,
			'vfooter':Footer
		},
		methods:{ 
			reload(){ 
				this.isRouterAlive = false; 
				this.$nextTick(function () { 
					this.isRouterAlive = true 
					}); 
			},
			//是否显示头部
			public_header:function (bool) {
				this.header_show = bool;
			},
			//是否显示底部
			public_footer:function (bool) {
				this.footer_show = bool;
			}
		},

	}
</script>

<style lang="scss" >


</style>



// WEBPACK FOOTER //
// src/App.vue